import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  TextField,
  Typography,
  useTheme,
  CardMedia,
  Card,
  CardContent,
  Grid,
  Divider,
  ButtonBase,
} from "@mui/material";
import { Archive, Unarchive } from "@mui/icons-material";
import { motion } from "framer-motion";
import { CreateOutlined, DeleteOutline } from "@mui/icons-material";
import { connect } from "react-redux";
import { setUserId } from "../../Redux/actions";
import "./post.css";
import { COLORS } from "colors/color";
import { styled } from "@mui/system";
import MyArrayInput from "../MyArrayInput";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { TbArchiveFilled } from "react-icons/tb";
import { TbArchive } from "react-icons/tb";
const ArchiveToggle = styled(motion.div)({
  position: "absolute",
  top: 5,
  right: 0,
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  borderRadius: "20px",
  transition: "background-color 0.3s",
});

const ArchiveIcon = styled(motion.div)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 50, // Increased width
  height: 50, // Increased height
  borderRadius: "50%",

  border: "1px solid #0001", // Thinner border
  color: COLORS.Button_OnHold,
  marginRight: 12,
  "& .MuiSvgIcon-root": {
    fontSize: 28, // Increased font size of the icon
  },
});


// const ArchiveLabel = styled(Typography)({
//   userSelect: "none",
//   fontWeight: 500,
// });
const StyledCard = styled(ButtonBase)(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  height: 242,
  borderRadius: "20px",
  boxShadow: "0 4px 40px 0 #0000000D",
  transition: "transform 0.3s ease-in-out",
  width: "100%",
  boxSizing: "border-box",
  backgroundColor: "#fff",
  // paddingLeft: "19px",
  // paddingRight: "19px",
  padding: "20px",
  "&:hover": {
    transform: "translateY(-5px)",
  },
}));
const StyledCardMedia = styled(CardMedia)({
  height: 200,
  objectFit: "cover",
});

const StyledCardContent = styled(CardContent)({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
});

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "10px",
  borderRadius: "8px",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "0 4px 10px rgba(0,0,0,0.6)",
  },
}));

function CardPost({
  postid,
  imageSrc,
  title,
  description,
  requirement,
  deadline,
  company,
  onDeletePost,
  updatePost,
  onSelectPost,
  archived,
  onArchivePost,
}) {
  const [postTitle, setPostTitle] = useState(title);
  const [postDescription, setPostDescription] = useState(description);
  const [postRequirement, setPostRequirement] = useState(requirement);
  const [postDeadline, setPostDeadline] = useState(deadline);
  const [postToDeleteId, setPostToDeleteId] = useState(null);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);

  const theme = useTheme();
  const userId = getUserIdFromAccessToken();
  const [isArchived, setIsArchived] = useState(archived);
  const handleArchiveChange = async () => {
    const newArchivedStatus = !isArchived;
    setIsArchived(newArchivedStatus);
    const animationDuration = 500; // 500ms, matching the rotation duration

    await new Promise((resolve) => setTimeout(resolve, animationDuration));

    await onArchivePost(postid, newArchivedStatus);
  };
  const handleEditClick = (event) => {
    event.stopPropagation();
    setOpen4(true);
  };

  const handleDeleteClick = (event) => {
    event.stopPropagation();
    setPostToDeleteId(postid);
    setOpen5(true);
  };
  function truncateText(text, maxLength) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }
  // useEffect(() => {
  //   console.log("this is the req :: ", imageSrc);
  // }, []);

  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      return decodedToken.user_id;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }
  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  async function handleUpdatePost() {
    setOpen4(false);
    const updatedPostData = {
      postid: postid,
      recruiter: userId,
      image: imageSrc,
      title: postTitle,
      description: postDescription,
      requirements: postRequirement,
      deadline: postDeadline,
      company: "pulse",
    };
    updatePost(updatedPostData);
  }

  return (
    <StyledCard onClick={onSelectPost}>
      {/* <StyledCardMedia component="img" image={imageSrc} alt={title} /> */}
      <StyledCardContent>
        <Typography
          component="div"
          gutterBottom
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#004f97",
            marginBottom: 1,
            textAlign: "left",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: "rgba(0, 79, 152, 0.5)",
            marginBottom: 2,
            textAlign: "left",
          }}
        >
          Deadline: {deadline}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "rgba(0, 0, 0, 0.4)",
            marginBottom: 2,
            textAlign: "left",
          }}
        >
          {truncateText(description, 200)}
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* <ArchiveToggle onClick={handleArchiveChange}>
            <ArchiveIcon
            // animate={{ rotate: isArchived ? 360 : 0 }}
            // transition={{ duration: 0.5 }}
            >
              {isArchived ? (
                <TbArchiveFilled fontSize="2rem" />
              ) : (
                <TbArchive fontSize="2rem" />
              )}
            </ArchiveIcon>
          </ArchiveToggle> */}
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={handleEditClick}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              color: "#004f97",
              boxShadow: "0px 4px 40px 0 #00000014",
              borderRadius: 1.25,
              textTransform: "none",
              fontSize: 10,
              fontWeight: 500,
              borderRadius: 2.5,
              fontFamily: "Poppins",
              "&:hover": {
                color: "#fff",
                boxShadow: "0px 4px 15px 0 rgba(0,0,0,0.1)",
              },
            }}
          >
            Edit post
          </Button>
          <Button
            variant="contained"
            startIcon={<DeleteIcon />}
            onClick={handleDeleteClick}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              color: "#ff0000",
              boxShadow: "0px 4px 40px 0 #00000014",
              borderRadius: 1.25,
              textTransform: "none",
              fontSize: 10,
              fontWeight: 500,
              borderRadius: 2.5,
              fontFamily: "Poppins",
              "&:hover": {
                color: "#fff",
                boxShadow: "0px 4px 10px 0 rgba(0,0,0,0.1)",
              },
            }}
          >
            Delete
          </Button>
        </Stack>
      </StyledCardContent>

      <Dialog
        open={open4}
        onClose={() => setOpen4(false)}
        fullWidth
        maxWidth="sm"
        onClick={(e) => e.stopPropagation()}
      >
        <DialogContent>
          <Stack spacing={2.5} margin={1}>
            <Typography
              fontSize={25}
              fontFamily={"sans-serif"}
              color={COLORS.pulse_color}
            >
              Update Post
            </Typography>
            <TextField
              variant="outlined"
              label="Title"
              value={postTitle}
              onChange={(event) => {
                setPostTitle(event.target.value);
                event.stopPropagation();
              }}
            />
            <TextField
              variant="outlined"
              label="Deadline"
              value={postDeadline}
              onChange={(event) => {
                setPostDeadline(event.target.value);
                event.stopPropagation();
              }}
            />
            <TextField
              variant="outlined"
              label="Description"
              value={postDescription}
              onChange={(event) => {
                event.stopPropagation();
                setPostDescription(event.target.value);
              }}
              multiline
              rows={6}
              fullWidth
            />
            <MyArrayInput
              value={postRequirement}
              onChange={setPostRequirement}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setOpen4(false)}
            sx={{
              color: COLORS.signIn,
              bgcolor: COLORS.white,
              ":hover": {
                bgcolor: COLORS.Button_OnHold,
                color: COLORS.signIn,
              },
            }}
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            onClick={handleUpdatePost}
            sx={{
              color: COLORS.white,
              bgcolor: COLORS.signIn,
              ":hover": {
                bgcolor: COLORS.Button_OnHold,
                color: COLORS.signIn,
              },
            }}
          >
            UPDATE
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={open5}
        onClose={() => setOpen5(false)}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            width: 270,
            height: 168,
            m: 0,
            borderRadius: 5,
            // boxShadow: 3,
            position: "relative",
            // boxShadow:'0 0 40px 0 #0000001A',
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "black",
              mb: 1,
              fontFamily: "Poppins",
              pt:2,
              px:2,
            }}
          >
            Are you sure?
          </Typography>
 
          <Divider
            sx={{
              mb: 1,
              borderColor: "#0000001A",
              borderWidth: "2px",
              width: "100%",
              // mx: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />

          <Typography
            variant="caption"
            sx={{
              color: "#00000080",
              mb: 2,
              fontSize: 12,
              fontFamily: "Poppins",
              px:2,
            }}
          >
            This action is irreversible
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            // justifyContent: "space-between",
            px: 4,
            pb: 2,
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} md={6} lg={6}>
              <Button
                variant="outlined"
                onClick={() => setOpen5(false)}
                sx={{
                  width: 100,
                  height: 40,
                  borderRadius: 2,
                  borderColor: "#0084ff",
                  color: "#0084ff",
                  textTransform: "none",
                  fontFamily: "Poppins",
                  fontSize: 13,
                  fontWeight: "400px",
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Button
                variant="contained"
                onClick={() => {
                  onDeletePost(postToDeleteId);
                  setOpen5(false);
                }}
                sx={{
                  width: 100,
                  height: 40,
                  borderRadius: 2,
                  bgcolor: "#ff0000",
                  color: "white",
                  textTransform: "none",
                  fontSize: 13,
                  fontFamily: "Poppins",
                  fontWeight: "400px",
                  "&:hover": {
                    bgcolor: "#ff0000",
                  },
                }}
              >
                Delete
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </StyledCard>
  );
}

CardPost.propTypes = {
  postid: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  requirement: PropTypes.arrayOf(PropTypes.string).isRequired,
  deadline: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  onDeletePost: PropTypes.func.isRequired,
  updatePost: PropTypes.func.isRequired,
  onSelectPost: PropTypes.func.isRequired,
  archived: PropTypes.bool.isRequired,
  onArchivePost: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userId: state.userId,
});

const mapDispatchToProps = {
  setUserId,
};

export default connect(mapStateToProps, mapDispatchToProps)(CardPost);
